import React from "react";

import CarouselSection from "./CarouselSection";
import SearchAndFilter from "../../SearchAndFilter";
import Summary from "./Summary";
const Registration = () => {
  return (
    <>
      <CarouselSection />
      <SearchAndFilter title="Summary" arrow inputWidth={"large"} />
      <Summary />
    </>
  );
};

export default Registration;
